import { LoadingArea } from '@consigli/facade';
import { useProject, useProjectId } from '@consigli/hooks';

import { useRegisterBreadcrumb } from '@/components';
import { PageHeader } from '@/components/page-header';

import { AddServiceForm } from './add-service-form/add-service-form';
import { EditProjectForm } from './edit-project-form';
import { ProjectVisibilityButton } from './project-visibility-button';
import { ServiceTable } from './service-table/service-table';

/**
 * Project Page for displaying a project and its services.
 * @returns The project page.
 */
export const ProjectPage = () => {
  const projectId = useProjectId();
  const IS_HIDDEN = true;
  const { project, isLoading: isLoadingProject } = useProject(projectId, IS_HIDDEN);

  useRegisterBreadcrumb(projectId, project?.name);

  return isLoadingProject || !project ? (
    <LoadingArea />
  ) : (
    <div className="flex flex-col gap-8">
      <PageHeader title="Project" subtitle={project.name}>
        <div className="flex gap-2">
          <EditProjectForm project={project} />
          <ProjectVisibilityButton />
          <AddServiceForm />
        </div>
      </PageHeader>
      <ServiceTable project={project} />
    </div>
  );
};
